"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "fieldtypes": {},
  "fields": {},
  "layouts": {}
};
exports.default = _default;
module.exports = exports.default;